
import { CreateReagentParams, CreateReagentResult } from "@/types/reagent.types";
import { uploadReagent } from "@/services/newReagentService";
import { dateToString } from "@/utils/dateUtils";

// Log when the module is loaded
console.log("reagentApi.ts - Exporting API functions");

/**
 * Creates a new reagent
 */
export const createReagent = async (params: CreateReagentParams): Promise<CreateReagentResult> => {
  // This implementation delegates to the uploadReagent function in newReagentService.ts
  return uploadReagent({
    name: params.name,
    catalogNumber: params.catalogNumber,
    category: params.category,
    description: params.description,
    amount: params.amount,
    unit: params.amount.replace(/[0-9.]/g, '').trim(),
    storageConditions: params.storageConditions,
    image: params.image,
    expiryDate: params.expiryDate ? dateToString(params.expiryDate) : null,
    numberOfPackages: params.numberOfPackages || "1"
  });
};

// Re-export functions from their new locations
export { fetchReagents } from './reagents/fetchReagents';
export { fetchReagentById } from './reagents/fetchReagentById';
export { uploadReagent } from './newReagentService';
